import styled from 'styled-components/macro';
import { white } from '../../styles/colors';
import { fontSize } from '../../styles/mixins';
import Input from '../Input';

export const ValueSelectorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  border-color: red;
`;

export const RoundButton = styled.button`
  background-color: ${({ theme }) => theme.buttonBgColorInverse};
  width: 22px;
  height: 22px;
  border-radius: 100%;
  border: 0;
  color: ${white};
  ${fontSize(25)};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  > span {
    ${fontSize(14)};
    height: 20px;
  }
`;
export const StyledInput = styled(Input)`
  width: calc(100% - 120px);

  > p[class*='SectionSmallText'] {
    text-align: center;
  }
  > p[class*='ErrorMessage'] {
    padding-top: 10px;
    text-align: center;
  }

  input {
    text-align: center;
    padding: 0;
  }
`;
